var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreMeal = function SvgPreMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35273 2.07076C3.35273 2.07076 3.02271 2.07075 2.71271 1.97075C2.40271 1.87075 1.78272 1.68075 1.28272 1.97075C0.782718 2.26075 0.662724 3.09076 0.882724 3.73076C1.10272 4.37076 1.71273 6.21077 1.95273 6.49077C2.19273 6.77077 2.40272 6.87076 2.69272 6.89076C2.98272 6.91076 3.26273 6.70076 3.48273 6.70076C3.70273 6.70076 4.05272 6.97076 4.41272 6.89076C4.77272 6.81076 4.93273 6.70075 5.29273 5.91075C5.65273 5.12075 6.22272 4.10078 6.22272 3.50078C6.22272 2.90078 6.17271 2.08077 5.46271 1.80077C4.75271 1.52077 4.20273 1.78077 3.98273 1.90077C3.76273 2.02077 3.62274 1.95076 3.36274 2.04076L3.35273 2.07076Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2827 1.95078H3.49269L3.2827 0.410767L2.85271 0.500793L3.2827 1.95078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49271 1.52078C3.49271 1.52078 3.45272 0.810787 4.04272 0.400787C4.63272 -0.00921294 5.37271 0.110779 5.37271 0.110779C5.37271 0.110779 5.44272 1.06079 4.63272 1.40079C3.82272 1.74079 3.48273 1.52078 3.48273 1.52078H3.49271Z",
    fill: "white"
  })));
};
export default SvgPreMeal;